// import React, { useEffect } from "react";
// import { motion, useAnimation } from "framer-motion";
// import { useInView } from "react-intersection-observer";

// const AnimatedNumber = ({ value }) => {
//   const controls = useAnimation();
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.5,
//   });

//   useEffect(() => {
//     if (inView) {
//       controls.start({
//         scale: [1, 1.2, 1],
//         transition: { duration: 0.5 },
//       });
//     }
//   }, [controls, inView]);

//   return (
//     <motion.span ref={ref} animate={controls} className="inline-block">
//       {value}
//     </motion.span>
//   );
// };

// const AnimatedSection = ({ children }) => {
//   const controls = useAnimation();
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   useEffect(() => {
//     if (inView) {
//       controls.start("visible");
//     }
//   }, [controls, inView]);

//   return (
//     <motion.div
//       ref={ref}
//       initial="hidden"
//       animate={controls}
//       variants={{
//         visible: { opacity: 1, y: 0 },
//         hidden: { opacity: 0, y: 50 },
//       }}
//       transition={{ duration: 0.5 }}
//     >
//       {children}
//     </motion.div>
//   );
// };

// const LeadGenerationPage = () => {
//   const industries = [
//     "Technology",
//     "Healthcare",
//     "Finance",
//     "Real Estate",
//     "E-commerce",
//     "Education",
//     "Manufacturing",
//     "Professional Services",
//   ];

//   return (
//     <div className="font-sans bg-gray-50 text-gray-800">
//       {/* Hero Section */}
//       <section className="relative bg-gradient-to-br from-blue-700 to-blue-900 text-white py-32 px-6 overflow-hidden">
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="container mx-auto text-center relative z-10"
//         >
//           <h1 className="text-4xl md:text-5xl font-bold mb-6">
//             Transform Your{" "}
//             <span className="text-yellow-300">Lead Generation</span>
//           </h1>
//           <p className="text-xl mb-8 max-w-3xl mx-auto">
//             Data-driven strategies that deliver <AnimatedNumber value="3-5x" />{" "}
//             more qualified leads for your business
//           </p>
//           <div className="flex flex-col sm:flex-row justify-center gap-4">
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="bg-white text-blue-700 px-8 py-4 rounded-lg font-semibold"
//             >
//               Get Started Today
//             </motion.button>
//             {/* <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="bg-transparent border-2 border-white px-8 py-4 rounded-lg font-semibold"
//             >
//               Call: +44 1416 282 052
//             </motion.button> */}
//           </div>
//         </motion.div>
//         <div className="absolute inset-0 bg-opacity-20 bg-black"></div>
//       </section>

//       {/* Stats Section */}
//       <AnimatedSection>
//         <section className="py-16 px-6 bg-white">
//           <div className="container mx-auto">
//             <div className="grid md:grid-cols-4 gap-8 text-center">
//               {[
//                 { value: "10,000+", label: "Leads Generated Monthly" },
//                 { value: "95%", label: "Data Accuracy" },
//                 { value: "3.5x", label: "Higher Conversion" },
//                 { value: "24/7", label: "Campaign Monitoring" },
//               ].map((stat, index) => (
//                 <motion.div
//                   key={index}
//                   whileHover={{ y: -5 }}
//                   className="bg-gray-50 p-6 rounded-xl"
//                 >
//                   <div className="text-4xl font-bold text-blue-600 mb-2">
//                     <AnimatedNumber value={stat.value} />
//                   </div>
//                   <p className="text-gray-600">{stat.label}</p>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </AnimatedSection>

//       {/* Services Section */}
//       <AnimatedSection>
//         <section className="py-16 px-6 bg-gray-50">
//           <div className="container mx-auto">
//             <div className="text-center mb-12">
//               <h2 className="text-3xl font-bold mb-4">
//                 <span className="text-blue-600">01.</span> Our Lead Generation
//                 Services
//               </h2>
//               <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//                 Comprehensive Solutionss tailored to your specific business needs
//                 and growth objectives
//               </p>
//             </div>

//             <div className="grid md:grid-cols-3 gap-8">
//               {[
//                 {
//                   title: "Data Scraping & Research",
//                   desc: "We employ advanced techniques to gather and verify high-quality lead data from multiple reliable sources.",
//                   icon: "🔍",
//                   features: [
//                     "Comprehensive data collection",
//                     "Precision targeting",
//                     "Continuous updates",
//                     "Compliance with regulations",
//                   ],
//                   color: "bg-blue-100",
//                 },
//                 {
//                   title: "Email Marketing Campaigns",
//                   desc: "Targeted email sequences designed to engage your ideal customers and drive conversions.",
//                   icon: "✉️",
//                   features: [
//                     "Strategic list building",
//                     "A/B tested content",
//                     "Automated sequences",
//                     "Detailed analytics",
//                   ],
//                   color: "bg-purple-100",
//                 },
//                 {
//                   title: "Telecalling & Outreach",
//                   desc: "Skilled communicators engaging leads through personalized conversations.",
//                   icon: "📞",
//                   features: [
//                     "Native language speakers",
//                     "Custom call scripts",
//                     "Lead qualification",
//                     "CRM integration",
//                   ],
//                   color: "bg-green-100",
//                 },
//               ].map((service, index) => (
//                 <motion.div
//                   key={index}
//                   whileHover={{ y: -10 }}
//                   className={`${service.color} p-8 rounded-xl shadow-md`}
//                 >
//                   <div className="text-4xl mb-4">{service.icon}</div>
//                   <h3 className="text-xl font-bold mb-3">{service.title}</h3>
//                   <p className="text-gray-600 mb-4">{service.desc}</p>
//                   <ul className="space-y-2">
//                     {service.features.map((feature, i) => (
//                       <li key={i} className="flex items-start">
//                         <span className="text-blue-500 mr-2">•</span>
//                         <span>{feature}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </AnimatedSection>

//       {/* Process Section */}
//       <AnimatedSection>
//         <section className="py-16 px-6 bg-white">
//           <div className="container mx-auto">
//             <div className="text-center mb-12">
//               <h2 className="text-3xl font-bold mb-4">
//                 <span className="text-blue-600">02.</span> Our 6-Step Lead
//                 Generation Process
//               </h2>
//               <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//                 A systematic approach that delivers measurable results
//               </p>
//             </div>

//             <div className="space-y-12">
//               {[
//                 {
//                   step: "1",
//                   title: "Discovery & Strategy",
//                   desc: "We conduct in-depth analysis of your business objectives, target market, and competition to develop a customized lead generation roadmap.",
//                   details: [
//                     "Market research",
//                     "Competitor analysis",
//                     "Buyer persona development",
//                     "Channel selection",
//                     "KPI establishment",
//                   ],
//                   image:
//                     "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
//                 },
//                 {
//                   step: "2",
//                   title: "Data Acquisition",
//                   desc: "Our team gathers and verifies high-quality lead data from multiple reliable sources while ensuring compliance with data protection regulations.",
//                   details: [
//                     "Multi-source collection",
//                     "Data validation",
//                     "Segmentation",
//                     "Compliance checks",
//                     "Database setup",
//                   ],
//                   image:
//                     "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
//                 },
//                 {
//                   step: "3",
//                   title: "Campaign Development",
//                   desc: "We create tailored messaging and outreach sequences designed to engage your ideal customers and guide them through the buyer's journey.",
//                   details: [
//                     "Content creation",
//                     "A/B testing setup",
//                     "Sequence planning",
//                     "Approval process",
//                     "CRM integration",
//                   ],
//                   image:
//                     "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
//                 },
//                 {
//                   step: "4",
//                   title: "Multi-Channel Execution",
//                   desc: "Coordinated outreach across email, phone, and digital channels for maximum impact and engagement.",
//                   details: [
//                     "Email deployment",
//                     "Call center activation",
//                     "Social integration",
//                     "CRM synchronization",
//                     "Initial follow-ups",
//                   ],
//                   image:
//                     "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
//                 },
//                 {
//                   step: "5",
//                   title: "Performance Optimization",
//                   desc: "Continuous monitoring and adjustment of campaigns based on real-time analytics and conversion data.",
//                   details: [
//                     "Daily reporting",
//                     "Conversion tracking",
//                     "Channel optimization",
//                     "Budget reallocation",
//                     "Message refinement",
//                   ],
//                   image:
//                     "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
//                 },
//                 {
//                   step: "6",
//                   title: "Results Delivery & Analysis",
//                   desc: "We provide qualified leads along with comprehensive reporting and recommendations for continuous improvement.",
//                   details: [
//                     "Lead handoff",
//                     "ROI analysis",
//                     "Recommendations",
//                     "Next steps planning",
//                     "Ongoing support",
//                   ],
//                   image:
//                     "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
//                 },
//               ].map((item, index) => (
//                 <motion.div
//                   key={index}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   initial={{ opacity: 0, y: 50 }}
//                   transition={{ duration: 0.5, delay: index * 0.1 }}
//                   viewport={{ once: true }}
//                   className="flex flex-col lg:flex-row items-start gap-8"
//                 >
//                   <div className="bg-blue-600 text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold flex-shrink-0">
//                     {item.step}
//                   </div>
//                   <div className="bg-gray-50 p-8 rounded-xl flex-1 w-full">
//                     <div className="flex flex-col lg:flex-row gap-8">
//                       <div className="lg:w-2/3">
//                         <h4 className="text-xl font-semibold mb-2">
//                           {item.title}
//                         </h4>
//                         <p className="text-gray-600 mb-4">{item.desc}</p>
//                         <ul className="space-y-2">
//                           {item.details.map((detail, i) => (
//                             <li key={i} className="flex items-start">
//                               <span className="text-blue-500 mr-2">•</span>
//                               <span>{detail}</span>
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                       <div className="lg:w-1/3">
//                         <img
//                           src={item.image}
//                           alt={`Step ${item.step}: ${item.title}`}
//                           className="rounded-lg w-full h-48 object-cover shadow-md"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </AnimatedSection>

//       {/* Industries Section */}
//       <AnimatedSection>
//         <section className="py-16 px-6 bg-gray-50">
//           <div className="container mx-auto">
//             <div className="text-center mb-12">
//               <h2 className="text-3xl font-bold mb-4">
//                 <span className="text-blue-600">03.</span> Industries We Serve
//               </h2>
//               <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//                 Our lead generation strategies are effective across multiple
//                 sectors
//               </p>
//             </div>

//             <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4">
//               {industries.map((industry, index) => (
//                 <motion.div
//                   key={index}
//                   whileHover={{ scale: 1.05 }}
//                   className="bg-white p-6 rounded-lg shadow-sm text-center hover:shadow-md transition"
//                 >
//                   <div className="text-blue-600 text-2xl mb-2">
//                     {index % 3 === 0 ? "🏢" : index % 3 === 1 ? "🏥" : "💻"}
//                   </div>
//                   <h3 className="font-semibold">{industry}</h3>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </AnimatedSection>

//       {/* Testimonials */}
//       <AnimatedSection>
//         <section className="py-16 px-6 bg-white">
//           <div className="container mx-auto">
//             <div className="text-center mb-12">
//               <h2 className="text-3xl font-bold mb-4">
//                 <span className="text-blue-600">04.</span> Client Success
//                 Stories
//               </h2>
//               <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//                 See how we've helped businesses achieve remarkable growth
//               </p>
//             </div>

//             <div className="grid md:grid-cols-3 gap-8">
//               {[
//                 {
//                   quote:
//                     "Augere Strategies  increased our qualified leads by 140% within 3 months. Their data-driven approach was exactly what we needed.",
//                   author: "Sarah Johnson",
//                   position: "Marketing Director, FinTech Solutionss",
//                   stat: "140%",
//                 },
//                 {
//                   quote:
//                     "The integrated email and calling strategy delivered 60% more new clients than our previous efforts. Highly recommended!",
//                   author: "Michael Chen",
//                   position: "CEO, TechInnovate",
//                   stat: "60%",
//                 },
//                 {
//                   quote:
//                     "Working with Augere was transformative. They helped us streamline our lead process and boost sales opportunities by 50%.",
//                   author: "Dr. Emily Rodriguez",
//                   position: "Practice Manager, HealthPlus",
//                   stat: "50%",
//                 },
//               ].map((testimonial, index) => (
//                 <motion.div
//                   key={index}
//                   whileHover={{ y: -5 }}
//                   className="bg-gray-50 p-8 rounded-xl relative"
//                 >
//                   <div className="absolute -top-4 -left-4 bg-blue-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold">
//                     {testimonial.stat}
//                   </div>
//                   <p className="text-gray-600 italic mb-6">
//                     "{testimonial.quote}"
//                   </p>
//                   <div>
//                     <p className="font-semibold">{testimonial.author}</p>
//                     <p className="text-gray-500 text-sm">
//                       {testimonial.position}
//                     </p>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </AnimatedSection>

//       {/* Final CTA */}
//       <AnimatedSection>
//         <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 px-6">
//           <div className="container mx-auto text-center">
//             <motion.h2
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//               className="text-3xl md:text-4xl font-bold mb-6"
//             >
//               Ready to Transform Your Lead Generation?
//             </motion.h2>
//             <motion.p
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               className="text-xl mb-8 max-w-3xl mx-auto"
//             >
//               Contact us today to discuss how we can help grow your business
//             </motion.p>
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.4 }}
//               className="flex flex-col sm:flex-row justify-center gap-4"
//             >
//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold"
//               >
//                 Get Started Now
//               </motion.button>
//               {/* <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="bg-transparent border-2 border-white px-8 py-4 rounded-lg font-semibold"
//               >
//                 Call: +44 1416 282 052
//               </motion.button> */}
//             </motion.div>
//           </div>
//         </section>
//       </AnimatedSection>
//     </div>
//   );
// };

// export default LeadGenerationPage;

import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import lead from "./images/gr.jpg";
import lead1 from "./images/tu.jpg";

const AnimatedNumber = ({ value }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  useEffect(() => {
    if (inView) {
      controls.start({
        scale: [1, 1.2, 1],
        transition: { duration: 0.5 },
      });
    }
  }, [controls, inView]);

  return (
    <motion.span ref={ref} animate={controls} className="inline-block">
      {value}
    </motion.span>
  );
};

const AnimatedSection = ({ children }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: 50 },
      }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

const LeadGenerationPage = () => {
  const navigate = useNavigate();
  const industries = [
    "Technology",
    "Healthcare",
    "Finance",
    "Real Estate",
    "E-commerce",
    "Education",
    "Manufacturing",
    "Professional Services",
    "Automotive",
  ];

  const handleContactRedirect = () => {
    navigate("/contact");
  };

  return (
    <div className="font-sans bg-gray-50 text-gray-800">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-700 to-blue-900 text-white py-32 px-6 overflow-hidden">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="container mx-auto text-center relative z-10"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Transform Your{" "}
            <span className="text-yellow-300">Lead Generation</span>
          </h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Data-driven strategies that deliver <AnimatedNumber value="3-5x" />{" "}
            more qualified leads for your business
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <motion.button
              onClick={handleContactRedirect}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-blue-700 px-8 py-4 rounded-lg font-semibold"
            >
              Get Started Today
            </motion.button>
          </div>
        </motion.div>
        <div className="absolute inset-0 bg-opacity-20 bg-black"></div>
      </section>

      {/* Stats Section */}
      <AnimatedSection>
        <section className="py-16 px-6 bg-white">
          <div className="container mx-auto">
            <div className="grid md:grid-cols-4 gap-8 text-center">
              {[
                { value: "10,000+", label: "Leads Generated Monthly" },
                { value: "95%", label: "Data Accuracy" },
                { value: "3.5x", label: "Higher Conversion" },
                { value: "24/7", label: "Campaign Monitoring" },
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -5 }}
                  className="bg-gray-50 p-6 rounded-xl"
                >
                  <div className="text-4xl font-bold text-blue-600 mb-2">
                    <AnimatedNumber value={stat.value} />
                  </div>
                  <p className="text-gray-600">{stat.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Services Section */}
      <AnimatedSection>
        <section className="py-16 px-6 bg-gray-50">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                <span className="text-blue-600">01.</span> Our Lead Generation
                Services
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Comprehensive Solutionss tailored to your specific business
                needs and growth objectives
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  title: "Data Scraping & Research",
                  desc: "We employ advanced techniques to gather and verify high-quality lead data from multiple reliable sources.",
                  icon: "🔍",
                  features: [
                    "Comprehensive data collection",
                    "Precision targeting",
                    "Continuous updates",
                    "Compliance with regulations",
                  ],
                  color: "bg-blue-100",
                },
                {
                  title: "Email Marketing Campaigns",
                  desc: "Targeted email sequences designed to engage your ideal customers and drive conversions.",
                  icon: "✉️",
                  features: [
                    "Strategic list building",

                    "Automated sequences",
                    "Detailed analytics",
                  ],
                  color: "bg-purple-100",
                },
                {
                  title: "Telecalling & Outreach",
                  desc: "Skilled communicators engaging leads through personalized conversations.",
                  icon: "📞",
                  features: [
                    "Native language speakers",
                    "Custom call scripts",
                    "Lead qualification",
                    "CRM integration",
                  ],
                  color: "bg-green-100",
                },
              ].map((service, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -10 }}
                  className={`${service.color} p-8 rounded-xl shadow-md`}
                >
                  <div className="text-4xl mb-4">{service.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.desc}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, i) => (
                      <li key={i} className="flex items-start">
                        <span className="text-blue-500 mr-2">•</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Process Section */}
      <AnimatedSection>
        <section className="py-16 px-6 bg-white">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                <span className="text-blue-600">02.</span> Our 6-Step Lead
                Generation Process
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                A systematic approach that delivers measurable results
              </p>
            </div>

            <div className="space-y-12">
              {[
                {
                  step: "1",
                  title: "Discovery & Strategy",
                  desc: "We conduct in-depth analysis of your business objectives, target market, and competition to develop a customized lead generation roadmap.",
                  details: [
                    "Market research",
                    "Competitor analysis",
                    "Buyer persona development",
                    "Channel selection",
                    "KPI establishment",
                  ],
                  image: lead,
                },
                {
                  step: "2",
                  title: "Data Acquisition",
                  desc: "Our team gathers and verifies high-quality lead data from multiple reliable sources while ensuring compliance with data protection regulations.",
                  details: [
                    "Multi-source collection",
                    "Data validation",
                    "Segmentation",
                    "Compliance checks",
                    "Database setup",
                  ],
                  image:
                    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
                },
                {
                  step: "3",
                  title: "Campaign Development",
                  desc: "We create tailored messaging and outreach sequences designed to engage your ideal customers and guide them through the buyer's journey.",
                  details: [
                    "Content creation",

                    "Sequence planning",
                    "Approval process",
                    "CRM integration",
                  ],
                  image: lead1,
                },
                {
                  step: "4",
                  title: "Multi-Channel Execution",
                  desc: "Coordinated outreach across email, phone, and digital channels for maximum impact and engagement.",
                  details: [
                    "Email deployment",
                    "Call center activation",
                    "Social integration",
                    "CRM synchronization",
                    "Initial follow-ups",
                  ],
                  image:
                    "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
                },
                {
                  step: "5",
                  title: "Performance Optimization",
                  desc: "Continuous monitoring and adjustment of campaigns based on real-time analytics and conversion data.",
                  details: [
                    "Daily reporting",
                    "Conversion tracking",
                    "Channel optimization",
                    "Budget reallocation",
                    "Message refinement",
                  ],
                  image:
                    "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
                },
                {
                  step: "6",
                  title: "Results Delivery & Analysis",
                  desc: "We provide qualified leads along with comprehensive reporting and recommendations for continuous improvement.",
                  details: [
                    "Lead handoff",
                    "ROI analysis",
                    "Recommendations",
                    "Next steps planning",
                    "Ongoing support",
                  ],
                  image:
                    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80",
                },
              ].map((item, index) => (
                <motion.div
                  key={index}
                  whileInView={{ opacity: 1, y: 0 }}
                  initial={{ opacity: 0, y: 50 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex flex-col lg:flex-row items-start gap-8"
                >
                  <div className="bg-blue-600 text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    {item.step}
                  </div>
                  <div className="bg-gray-50 p-8 rounded-xl flex-1 w-full">
                    <div className="flex flex-col lg:flex-row gap-8">
                      <div className="lg:w-2/3">
                        <h4 className="text-xl font-semibold mb-2">
                          {item.title}
                        </h4>
                        <p className="text-gray-600 mb-4">{item.desc}</p>
                        <ul className="space-y-2">
                          {item.details.map((detail, i) => (
                            <li key={i} className="flex items-start">
                              <span className="text-blue-500 mr-2">•</span>
                              <span>{detail}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="lg:w-1/3">
                        <img
                          src={item.image}
                          alt={`Step ${item.step}: ${item.title}`}
                          className="rounded-lg w-full h-48 object-cover shadow-md"
                        />
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Industries Section */}
      <AnimatedSection>
        <section className="py-16 px-6 bg-gray-50">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                <span className="text-blue-600">03.</span> Industries We Serve
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Our lead generation strategies are effective across multiple
                sectors
              </p>
            </div>

            <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4">
              {industries.map((industry, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.05 }}
                  className="bg-white p-6 rounded-lg shadow-sm text-center hover:shadow-md transition"
                >
                  <div className="text-blue-600 text-2xl mb-2">
                    {index % 3 === 0 ? "🏢" : index % 3 === 1 ? "🏥" : "💻"}
                  </div>
                  <h3 className="font-semibold">{industry}</h3>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Testimonials */}
      <AnimatedSection>
        <section className="py-16 px-6 bg-white">
          <div className="container mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                <span className="text-blue-600">04.</span> Client Success
                Stories
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                See how we've helped businesses achieve remarkable growth
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  quote:
                    "Augere Strategies  increased our qualified leads within 3 months. Their data-driven approach was  what we needed.",
                  author: "Sarah Johnson",
                  position: "Marketing Director, FinTech Solutionss",
                  stat: "140%",
                },
                {
                  quote:
                    "The integrated email and calling strategy delivered 30% more new clients than our previous efforts. Highly recommended!",
                  author: "Michael Chen",
                  position: "CEO, TechInnovate",
                  stat: "30%",
                },
                {
                  quote:
                    " They helped us streamline our lead process and boost sales opportunities by 15%.",
                  author: "Dr. Emily Rodriguez",
                  position: "Practice Manager, HealthPlus",
                  stat: "15%",
                },
              ].map((testimonial, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -5 }}
                  className="bg-gray-50 p-8 rounded-xl relative"
                >
                  <div className="absolute -top-4 -left-4 bg-blue-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold">
                    {testimonial.stat}
                  </div>
                  <p className="text-gray-600 italic mb-6">
                    "{testimonial.quote}"
                  </p>
                  <div>
                    <p className="font-semibold">{testimonial.author}</p>
                    <p className="text-gray-500 text-sm">
                      {testimonial.position}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Final CTA */}
      <AnimatedSection>
        <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 px-6">
          <div className="container mx-auto text-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-3xl md:text-4xl font-bold mb-6"
            >
              Ready to Transform Your Lead Generation?
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-xl mb-8 max-w-3xl mx-auto"
            >
              Contact us today to discuss how we can help grow your business
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="flex flex-col sm:flex-row justify-center gap-4"
            >
              <motion.button
                onClick={handleContactRedirect}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold"
              >
                Get Started Now
              </motion.button>
            </motion.div>
          </div>
        </section>
      </AnimatedSection>
    </div>
  );
};

export default LeadGenerationPage;
